import { createContext, useContext, useSyncExternalStore } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api, ApiError, type Me } from './lib/api';

/** The signed-in member (null when not signed in). */
export function useMe() {
  return useQuery<Me | null>({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await api<Me>('/auth/me');
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 5 * 60_000,
  });
}

export type ToastFn = (msg: string, undo?: () => void) => void;
export const ToastCtx = createContext<ToastFn>(() => {});
export const useToast = () => useContext(ToastCtx);

const PHONE = '(max-width: 600px)';
// module level: the same functions on every render (otherwise React would re-subscribe on every keystroke)
const phoneQuery = () => window.matchMedia(PHONE);
const onPhoneChange = (cb: () => void) => {
  const m = phoneQuery();
  m.addEventListener('change', cb);
  return () => m.removeEventListener('change', cb);
};
const isPhone = () => phoneQuery().matches;
/** Phone layout (portrait, up to 600px – the same breakpoint as the CSS); follows rotation and resizing. */
export function usePhone() {
  return useSyncExternalStore(onPhoneChange, isPhone);
}
